export default __webpack_public_path__ + "static/media/img_11.5c1fac0d.JPG";